module.exports = __webpack_public_path__ + "img/caption.6f36d364.svg";